import React from "react";

/**
 * Unified 3D Isometric Icon Family
 * Consistent light source (top-left), soft ambient drop shadow,
 * rounded corners, satin sheen, and theme-harmonious palette (Teal, Slate, Sky, Amber).
 */

// 1. Unified 3D Calendar Icon (Reddish / Coral Palette)
export const Calendar3DIcon = ({ size = 28, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="calRedBody" x1="4" y1="8" x2="28" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#FF6B6B" />
        <stop offset="50%" stopColor="#F43F5E" />
        <stop offset="100%" stopColor="#E11D48" />
      </linearGradient>
      <linearGradient id="calRedTop" x1="4" y1="8" x2="28" y2="13" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#FFA07A" />
        <stop offset="100%" stopColor="#F43F5E" />
      </linearGradient>
      <filter id="calRedShadow" x="1" y="4" width="30" height="26" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#F43F5E" floodOpacity="0.25" />
      </filter>
    </defs>
    <g filter="url(#calRedShadow)">
      {/* Calendar Base Plate */}
      <rect x="4" y="9" width="24" height="19" rx="4" fill="url(#calRedBody)" />
      {/* Top Banner Stripe */}
      <path d="M4 13C4 10.7909 5.79086 9 8 9H24C26.2091 9 28 10.7909 28 13V13.5H4V13Z" fill="url(#calRedTop)" />
      {/* White Sheet Plate */}
      <rect x="5.5" y="14" width="21" height="12.5" rx="2.5" fill="#FFFFFF" fillOpacity="0.95" />
      {/* Date Sheet Grid Dots */}
      <rect x="7.5" y="16.5" width="3" height="2" rx="0.5" fill="#F43F5E" fillOpacity="0.7" />
      <rect x="12.5" y="16.5" width="3" height="2" rx="0.5" fill="#E11D48" />
      <rect x="17.5" y="16.5" width="3" height="2" rx="0.5" fill="#F43F5E" fillOpacity="0.7" />
      <rect x="22.5" y="16.5" width="3" height="2" rx="0.5" fill="#E11D48" />
      <rect x="7.5" y="20.5" width="3" height="2" rx="0.5" fill="#E11D48" />
      <rect x="12.5" y="20.5" width="3" height="2" rx="0.5" fill="#FF6B6B" />
      <rect x="17.5" y="20.5" width="3" height="2" rx="0.5" fill="#E11D48" />
      <rect x="22.5" y="20.5" width="3" height="2" rx="0.5" fill="#F43F5E" fillOpacity="0.7" />
      {/* Top Metallic Spiral Binder Loops */}
      <rect x="8" y="6.5" width="2.5" height="5" rx="1.25" fill="#E2E8F0" stroke="#CBD5E1" strokeWidth="0.5" />
      <rect x="14.75" y="6.5" width="2.5" height="5" rx="1.25" fill="#E2E8F0" stroke="#CBD5E1" strokeWidth="0.5" />
      <rect x="21.5" y="6.5" width="2.5" height="5" rx="1.25" fill="#E2E8F0" stroke="#CBD5E1" strokeWidth="0.5" />
    </g>
  </svg>
);


export const ExperienceShield3DIcon = ({ size = 26, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="amExpShieldGrad" x1="4" y1="4" x2="28" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#38BDF8" />
        <stop offset="45%" stopColor="#00BADA" />
        <stop offset="100%" stopColor="#0284C7" />
      </linearGradient>
      <linearGradient id="amExpShieldSheen" x1="8" y1="6" x2="24" y2="16" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.65" />
        <stop offset="100%" stopColor="#FFFFFF" stopOpacity="0" />
      </linearGradient>
      <filter id="amExpShieldShadow" x="1" y="2" width="30" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#0284C7" floodOpacity="0.28" />
      </filter>
    </defs>
    <g filter="url(#amExpShieldShadow)">
      <path
        d="M16 4L6 7.5V15.5C6 21.8 10.3 27.2 16 28.5C21.7 27.2 26 21.8 26 15.5V7.5L16 4Z"
        fill="url(#amExpShieldGrad)"
      />
      <path
        d="M16 5.5L7.5 8.5V15.5C7.5 20.8 11.2 25.5 16 26.8V5.5Z"
        fill="url(#amExpShieldSheen)"
      />
      <path
        d="M16 10V20M11 15H21"
        stroke="#FFFFFF"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
// 2. Unified 3D Video Camcorder Icon
export const Video3DIcon = ({ size = 28, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="vidUniBody" x1="3" y1="8" x2="21" y2="24" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#2DD4BF" />
        <stop offset="50%" stopColor="#0D9488" />
        <stop offset="100%" stopColor="#115E59" />
      </linearGradient>
      <linearGradient id="vidUniLens" x1="19" y1="10" x2="29" y2="22" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#5EEAD4" />
        <stop offset="100%" stopColor="#0F766E" />
      </linearGradient>
      <filter id="vidUniShadow" x="1" y="4" width="30" height="26" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#0D9488" floodOpacity="0.2" />
      </filter>
    </defs>
    <g filter="url(#vidUniShadow)">
      {/* Main Camera Body */}
      <rect x="3" y="9.5" width="17" height="13" rx="3.5" fill="url(#vidUniBody)" />
      {/* Top Handle */}
      <rect x="6.5" y="7.5" width="9" height="3" rx="1.5" fill="#5EEAD4" />
      {/* Perspective Lens Cone */}
      <path
        d="M20 12.5L27.4 8.6C28.2 8.2 29 8.8 29 9.7V22.3C29 23.2 28.2 23.8 27.4 23.4L20 19.5V12.5Z"
        fill="url(#vidUniLens)"
      />
      {/* Lens Highlight Circle */}
      <circle cx="28" cy="16" r="1.5" fill="#FFFFFF" fillOpacity="0.7" />
      {/* Gloss Highlight on Main Body */}
      <rect x="5.5" y="11.5" width="12" height="2.5" rx="1.25" fill="#FFFFFF" fillOpacity="0.35" />
      <circle cx="15.5" cy="18" r="1.25" fill="#FFFFFF" fillOpacity="0.4" />
    </g>
  </svg>
);

// 3. Unified 3D Location Marker Pin Icon (Reddish / Coral Palette)
export const Location3DIcon = ({ size = 28, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="pinRedBody" x1="6" y1="4" x2="26" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#FF6B6B" />
        <stop offset="50%" stopColor="#F43F5E" />
        <stop offset="100%" stopColor="#E11D48" />
      </linearGradient>
      <filter id="pinRedShadow" x="2" y="2" width="28" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#F43F5E" floodOpacity="0.25" />
      </filter>
    </defs>
    <g filter="url(#pinRedShadow)">
      {/* Pin Body */}
      <path
        d="M16 4C10.4772 4 6 8.47715 6 14C6 20.8 14.5 27.2 15.35 27.82C15.74 28.1 16.26 28.1 16.65 27.82C17.5 27.2 26 20.8 26 14C26 8.47715 21.5228 4 16 4Z"
        fill="url(#pinRedBody)"
      />
      {/* Inner White Dot */}
      <circle cx="16" cy="13.5" r="4" fill="#FFFFFF" />
      {/* Top Gloss Highlight */}
      <ellipse cx="14" cy="8" rx="4" ry="1.8" fill="#FFFFFF" fillOpacity="0.4" />
    </g>
  </svg>
);

// 4. Unified 3D Clock / Duration Icon
export const Clock3DIcon = ({ size = 28, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="clkUniBody" x1="4" y1="4" x2="28" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#00C8E8" />
        <stop offset="60%" stopColor="#00BADA" />
        <stop offset="100%" stopColor="#0891B2" />
      </linearGradient>
      <filter id="clkUniShadow" x="1" y="2" width="30" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#0891B2" floodOpacity="0.2" />
      </filter>
    </defs>
    <g filter="url(#clkUniShadow)">
      <circle cx="16" cy="16" r="12" fill="url(#clkUniBody)" />
      {/* Clock Face Inner Circle */}
      <circle cx="16" cy="16" r="9.5" fill="#FFFFFF" />
      {/* Clock Hands */}
      <line x1="16" y1="16" x2="16" y2="10.5" stroke="#0F172A" strokeWidth="2" strokeLinecap="round" />
      <line x1="16" y1="16" x2="20.5" y2="16" stroke="#0F172A" strokeWidth="2" strokeLinecap="round" />
      {/* Center Pivot */}
      <circle cx="16" cy="16" r="1.5" fill="#00BADA" />
      {/* Outer Gloss Highlight */}
      <path d="M8 11C10 7.5 13 6 16 6" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeOpacity="0.6" />
    </g>
  </svg>
);

// 5. Unified 3D Hybrid Broadcast Icon
export const Broadcast3DIcon = ({ size = 28, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="bcUniGrad" x1="4" y1="6" x2="28" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#818CF8" />
        <stop offset="50%" stopColor="#6366F1" />
        <stop offset="100%" stopColor="#4F46E5" />
      </linearGradient>
      <filter id="bcUniShadow" x="1" y="3" width="30" height="26" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#4F46E5" floodOpacity="0.2" />
      </filter>
    </defs>
    <g filter="url(#bcUniShadow)">
      <circle cx="16" cy="20" r="4" fill="url(#bcUniGrad)" />
      {/* Waves */}
      <path d="M10 14C13.3 11 18.7 11 22 14" stroke="url(#bcUniGrad)" strokeWidth="2.5" strokeLinecap="round" />
      <path d="M6 9C11.5 4.5 20.5 4.5 26 9" stroke="url(#bcUniGrad)" strokeWidth="2.5" strokeLinecap="round" />
      {/* Base Stem */}
      <line x1="16" y1="24" x2="16" y2="27" stroke="#6366F1" strokeWidth="2.5" strokeLinecap="round" />
    </g>
  </svg>
);

// 6. Unified 3D Admission Ticket Icon
export const Ticket3DIcon = ({ size = 28, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="tktUniGrad" x1="4" y1="8" x2="28" y2="24" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#FBBF24" />
        <stop offset="60%" stopColor="#F59E0B" />
        <stop offset="100%" stopColor="#D97706" />
      </linearGradient>
      <filter id="tktUniShadow" x="1" y="5" width="30" height="22" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#D97706" floodOpacity="0.2" />
      </filter>
    </defs>
    <g filter="url(#tktUniShadow)">
      <path
        d="M4 11C4 9.9 4.9 9 6 9H26C27.1 9 28 9.9 28 11C26.9 11 26 11.9 26 13C26 14.1 26.9 15 28 15V17C26.9 17 26 17.9 26 19C26 20.1 26.9 21 28 21C28 22.1 27.1 23 26 23H6C4.9 23 4 22.1 4 21C5.1 21 6 20.1 6 19C6 17.9 5.1 17 4 17V15C5.1 15 6 14.1 6 13C6 11.9 5.1 11 4 11Z"
        fill="url(#tktUniGrad)"
      />
      {/* Dashed Perforation Line */}
      <line x1="12" y1="10" x2="12" y2="22" stroke="#FFFFFF" strokeWidth="1.5" strokeDasharray="2 2" strokeOpacity="0.85" />
      {/* Star / Sparkle */}
      <circle cx="20" cy="16" r="2" fill="#FFFFFF" fillOpacity="0.9" />
    </g>
  </svg>
);

// 7. Unified 3D Users Group Icon
export const Users3DIcon = ({ size = 28, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="usrUniMain" x1="10" y1="8" x2="26" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#38BDF8" />
        <stop offset="60%" stopColor="#0284C7" />
        <stop offset="100%" stopColor="#0369A1" />
      </linearGradient>
      <linearGradient id="usrUniSec" x1="4" y1="10" x2="16" y2="26" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#93C5FD" />
        <stop offset="100%" stopColor="#60A5FA" />
      </linearGradient>
      <filter id="usrUniShadow" x="1" y="4" width="30" height="26" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#0284C7" floodOpacity="0.2" />
      </filter>
    </defs>
    <g filter="url(#usrUniShadow)">
      {/* Background User */}
      <circle cx="11" cy="13" r="4" fill="url(#usrUniSec)" />
      <path d="M5 24C5 20.7 7.7 18 11 18C12.5 18 13.9 18.6 15 19.5C14.4 20.8 14 22.3 14 24H5Z" fill="url(#usrUniSec)" />
      {/* Foreground User */}
      <circle cx="20" cy="12" r="4.5" fill="url(#usrUniMain)" />
      <path d="M13 24C13 20.1 16.1 17 20 17C23.9 17 27 20.1 27 24H13Z" fill="url(#usrUniMain)" />
      {/* Head Highlight */}
      <ellipse cx="18.5" cy="10" rx="1.5" ry="0.8" fill="#FFFFFF" fillOpacity="0.4" />
    </g>
  </svg>
);

// 8. Unified 3D Add To Calendar Icon (Reddish / Coral with Action Badge)
export const AddToCalendar3DIcon = ({ size = 28, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="addCalRedBody" x1="4" y1="6" x2="26" y2="26" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#FF6B6B" />
        <stop offset="60%" stopColor="#F43F5E" />
        <stop offset="100%" stopColor="#E11D48" />
      </linearGradient>
      <linearGradient id="addCalRedTop" x1="4" y1="6" x2="26" y2="11" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#FFA07A" />
        <stop offset="100%" stopColor="#F43F5E" />
      </linearGradient>
      <linearGradient id="addBadgeGrad" x1="17" y1="17" x2="29" y2="29" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#00E5FF" />
        <stop offset="50%" stopColor="#00BADA" />
        <stop offset="100%" stopColor="#0891B2" />
      </linearGradient>
      <filter id="addCalRedShadow" x="1" y="2" width="30" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#F43F5E" floodOpacity="0.25" />
      </filter>
      <filter id="addBadgeShadow" x="16" y="16" width="15" height="15" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="1.5" stdDeviation="1" floodColor="#0891B2" floodOpacity="0.35" />
      </filter>
    </defs>
    <g filter="url(#addCalRedShadow)">
      {/* Calendar Base Plate */}
      <rect x="3.5" y="7.5" width="22" height="18.5" rx="3.5" fill="url(#addCalRedBody)" />
      {/* Top Header Stripe */}
      <path d="M3.5 11.5C3.5 9.29 5.29 7.5 7.5 7.5H21.5C23.71 7.5 25.5 9.29 25.5 11.5V12H3.5V11.5Z" fill="url(#addCalRedTop)" />
      {/* Inner White Sheet */}
      <rect x="5" y="12.5" width="19" height="12" rx="2" fill="#FFFFFF" fillOpacity="0.95" />
      {/* Date Sheet Grid Dots */}
      <rect x="7" y="14.5" width="2.5" height="2" rx="0.5" fill="#F43F5E" fillOpacity="0.7" />
      <rect x="11" y="14.5" width="2.5" height="2" rx="0.5" fill="#F43F5E" fillOpacity="0.7" />
      <rect x="15" y="14.5" width="2.5" height="2" rx="0.5" fill="#F43F5E" fillOpacity="0.7" />
      <rect x="7" y="18" width="2.5" height="2" rx="0.5" fill="#E11D48" fillOpacity="0.7" />
      <rect x="11" y="18" width="2.5" height="2" rx="0.5" fill="#E11D48" fillOpacity="0.7" />
      {/* Top Rings */}
      <rect x="7.5" y="5" width="2" height="4.5" rx="1" fill="#E2E8F0" stroke="#CBD5E1" strokeWidth="0.5" />
      <rect x="19.5" y="5" width="2" height="4.5" rx="1" fill="#E2E8F0" stroke="#CBD5E1" strokeWidth="0.5" />
    </g>
    {/* Prominent 3D Plus Action Badge on bottom right */}
    <g filter="url(#addBadgeShadow)">
      <circle cx="23.5" cy="23.5" r="5.5" fill="url(#addBadgeGrad)" stroke="#FFFFFF" strokeWidth="1.5" />
      {/* Plus icon inside badge */}
      <line x1="23.5" y1="20.5" x2="23.5" y2="26.5" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
      <line x1="20.5" y1="23.5" x2="26.5" y2="23.5" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" />
    </g>
  </svg>
);

// 9. Unified 3D Web Globe Icon (for Website Link)
export const Globe3DIcon = ({ size = 28, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="glbUniBody" x1="4" y1="4" x2="28" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#38BDF8" />
        <stop offset="50%" stopColor="#0284C7" />
        <stop offset="100%" stopColor="#0369A1" />
      </linearGradient>
      <filter id="glbUniShadow" x="1" y="2" width="30" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#0284C7" floodOpacity="0.25" />
      </filter>
    </defs>
    <g filter="url(#glbUniShadow)">
      {/* Globe Main Sphere */}
      <circle cx="16" cy="16" r="12" fill="url(#glbUniBody)" />
      {/* Equator & Parallels */}
      <line x1="4" y1="16" x2="28" y2="16" stroke="#FFFFFF" strokeWidth="1.5" strokeOpacity="0.8" />
      <path d="M6 10.5C9.5 12.5 22.5 12.5 26 10.5" stroke="#FFFFFF" strokeWidth="1.2" strokeOpacity="0.6" fill="none" />
      <path d="M6 21.5C9.5 19.5 22.5 19.5 26 21.5" stroke="#FFFFFF" strokeWidth="1.2" strokeOpacity="0.6" fill="none" />
      {/* Central Meridian Ellipse */}
      <ellipse cx="16" cy="16" rx="6" ry="12" stroke="#FFFFFF" strokeWidth="1.5" strokeOpacity="0.8" fill="none" />
      {/* Center Vertical Axis */}
      <line x1="16" y1="4" x2="16" y2="28" stroke="#FFFFFF" strokeWidth="1.2" strokeOpacity="0.6" />
      {/* Gloss Highlight */}
      <path d="M8 11C10 7.5 13 6 16 6" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeOpacity="0.6" />
    </g>
  </svg>
);

// 10. Unified 3D In-Person Event Icon (Physical Attendee with Check-in Badge)
export const InPerson3DIcon = ({ size = 28, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="inPersonBodyGrad" x1="6" y1="8" x2="26" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#FF6B6B" />
        <stop offset="50%" stopColor="#F43F5E" />
        <stop offset="100%" stopColor="#E11D48" />
      </linearGradient>
      <linearGradient id="inPersonHeadGrad" x1="11" y1="5" x2="21" y2="17" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#FFA07A" />
        <stop offset="50%" stopColor="#F43F5E" />
        <stop offset="100%" stopColor="#BE123C" />
      </linearGradient>
      <linearGradient id="inPersonBadgeGrad" x1="18" y1="18" x2="28" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#38BDF8" />
        <stop offset="50%" stopColor="#0284C7" />
        <stop offset="100%" stopColor="#0369A1" />
      </linearGradient>
      <filter id="inPersonShadow" x="2" y="3" width="28" height="27" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#F43F5E" floodOpacity="0.25" />
      </filter>
      <filter id="inPersonBadgeShadow" x="17" y="17" width="13" height="13" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="1" stdDeviation="1" floodColor="#0284C7" floodOpacity="0.3" />
      </filter>
    </defs>
    <g filter="url(#inPersonShadow)">
      {/* 3D Person Torso */}
      <path
        d="M7.5 25.5C7.5 19.8 11.2 16 16 16C20.8 16 24.5 19.8 24.5 25.5C24.5 26.3 23.8 27 23 27H9C8.2 27 7.5 26.3 7.5 25.5Z"
        fill="url(#inPersonBodyGrad)"
      />
      {/* 3D Person Head */}
      <circle cx="16" cy="10.5" r="5" fill="url(#inPersonHeadGrad)" />
      {/* Head Gloss Highlight */}
      <ellipse cx="14.5" cy="8.2" rx="2" ry="1.1" fill="#FFFFFF" fillOpacity="0.45" />
      {/* Torso Collar / Lanyard line */}
      <path
        d="M13.5 16.5L16 20.5L18.5 16.5"
        stroke="#FFFFFF"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeOpacity="0.7"
      />
    </g>
    {/* Physical In-Person Attendance / Check-in Badge on Bottom-Right */}
    <g filter="url(#inPersonBadgeShadow)">
      <circle cx="23" cy="23" r="5" fill="url(#inPersonBadgeGrad)" stroke="#FFFFFF" strokeWidth="1.5" />
      {/* Checkmark inside Badge */}
      <path
        d="M20.5 23L22.2 24.7L25.5 21.3"
        stroke="#FFFFFF"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

// 11. Unified 3D Attendees / Community Crowd Icon
export const Attendees3DIcon = ({ size = 28, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="attCenterGrad" x1="10" y1="7" x2="22" y2="26" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#38BDF8" />
        <stop offset="60%" stopColor="#0284C7" />
        <stop offset="100%" stopColor="#0369A1" />
      </linearGradient>
      <linearGradient id="attSideGrad" x1="4" y1="9" x2="28" y2="26" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#A5B4FC" />
        <stop offset="60%" stopColor="#818CF8" />
        <stop offset="100%" stopColor="#6366F1" />
      </linearGradient>
      <linearGradient id="attStarGrad" x1="22" y1="4" x2="28" y2="10" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#FDE047" />
        <stop offset="100%" stopColor="#EAB308" />
      </linearGradient>
      <filter id="attShadow" x="1" y="3" width="30" height="26" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#0284C7" floodOpacity="0.22" />
      </filter>
    </defs>
    <g filter="url(#attShadow)">
      {/* Left Attendee Silhouette */}
      <circle cx="9" cy="12.5" r="3.2" fill="url(#attSideGrad)" />
      <path d="M3.5 25C3.5 21.2 5.8 18.2 9 18.2C10.6 18.2 12 19 13 20.3C12.1 21.7 11.5 23.3 11.5 25H3.5Z" fill="url(#attSideGrad)" />

      {/* Right Attendee Silhouette */}
      <circle cx="23" cy="12.5" r="3.2" fill="url(#attSideGrad)" />
      <path d="M20.5 25C20.5 23.3 19.9 21.7 19 20.3C20 19 21.4 18.2 23 18.2C26.2 18.2 28.5 21.2 28.5 25H20.5Z" fill="url(#attSideGrad)" />

      {/* Center Main Attendee (Foreground) */}
      <circle cx="16" cy="10" r="4.3" fill="url(#attCenterGrad)" />
      <ellipse cx="14.8" cy="8" rx="1.6" ry="0.9" fill="#FFFFFF" fillOpacity="0.45" />
      <path d="M9.5 25C9.5 20.3 12.4 16.5 16 16.5C19.6 16.5 22.5 20.3 22.5 25H9.5Z" fill="url(#attCenterGrad)" />

      {/* Community Sparkle / Activity Badge */}
      <circle cx="24.5" cy="7.5" r="2.2" fill="url(#attStarGrad)" />
      <path d="M24.5 4.5L25.2 6.8L27.5 7.5L25.2 8.2L24.5 10.5L23.8 8.2L21.5 7.5L23.8 6.8L24.5 4.5Z" fill="#FFFFFF" fillOpacity="0.9" />
    </g>
  </svg>
);

// 12. Unified 3D Speaker / Microphone Icon
export const Speaker3DIcon = ({ size = 28, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="spkCapGrad" x1="11" y1="4" x2="21" y2="18" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#00E5FF" />
        <stop offset="50%" stopColor="#00BADA" />
        <stop offset="100%" stopColor="#0891B2" />
      </linearGradient>
      <linearGradient id="spkStandGrad" x1="8" y1="12" x2="24" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#94A3B8" />
        <stop offset="100%" stopColor="#475569" />
      </linearGradient>
      <filter id="spkShadow" x="2" y="2" width="28" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#0891B2" floodOpacity="0.22" />
      </filter>
    </defs>
    <g filter="url(#spkShadow)">
      {/* Mic Capsule */}
      <rect x="11.5" y="4" width="9" height="14" rx="4.5" fill="url(#spkCapGrad)" />
      {/* Mesh Grille Highlights */}
      <line x1="12" y1="8.5" x2="20" y2="8.5" stroke="#FFFFFF" strokeWidth="1" strokeOpacity="0.75" />
      <line x1="12" y1="12.5" x2="20" y2="12.5" stroke="#FFFFFF" strokeWidth="1" strokeOpacity="0.75" />
      <line x1="16" y1="4.5" x2="16" y2="17.5" stroke="#FFFFFF" strokeWidth="1" strokeOpacity="0.5" />
      {/* Capsule Gloss Sheen */}
      <ellipse cx="14" cy="6.5" rx="1.5" ry="0.8" fill="#FFFFFF" fillOpacity="0.6" />

      {/* U-shaped Cradle */}
      <path
        d="M8.5 12C8.5 16.1421 11.8579 19.5 16 19.5C20.1421 19.5 23.5 16.1421 23.5 12"
        stroke="url(#spkStandGrad)"
        strokeWidth="2.2"
        strokeLinecap="round"
      />
      {/* Stand Stem */}
      <line x1="16" y1="19.5" x2="16" y2="25.5" stroke="url(#spkStandGrad)" strokeWidth="2.2" strokeLinecap="round" />
      {/* Base Foot */}
      <line x1="10.5" y1="26" x2="21.5" y2="26" stroke="url(#spkStandGrad)" strokeWidth="2.5" strokeLinecap="round" />
    </g>
  </svg>
);

// 13. Unified 3D Category / Specialty Tag Icon
export const Category3DIcon = ({ size = 20, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="tag3dBody" x1="4" y1="4" x2="28" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#00E5FF" />
        <stop offset="50%" stopColor="#00BADA" />
        <stop offset="100%" stopColor="#0891B2" />
      </linearGradient>
      <linearGradient id="tag3dHighlight" x1="6" y1="6" x2="22" y2="22" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.8" />
        <stop offset="100%" stopColor="#FFFFFF" stopOpacity="0" />
      </linearGradient>
      <filter id="tag3dShadow" x="1" y="2" width="30" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#0891B2" floodOpacity="0.3" />
      </filter>
    </defs>
    <g filter="url(#tag3dShadow)">
      {/* 3D Isometric Tag Shape (Angled) */}
      <path
        d="M6 14.5V7C6 5.89543 6.89543 5 8 5H15.5C16.0304 5 16.5391 5.21071 16.9142 5.58579L26.4142 15.0858C27.1953 15.8668 27.1953 17.1332 26.4142 17.9142L17.9142 26.4142C17.1332 27.1953 15.8668 27.1953 15.0858 26.4142L5.58579 16.9142C5.21071 16.5391 5 16.0304 5 15.5V14.5H6Z"
        fill="url(#tag3dBody)"
      />
      {/* Gloss Highlight across facet */}
      <path
        d="M8 6.5H15C15.4 6.5 15.8 6.65 16.1 6.95L24 14.85L21.5 17.35L13.65 9.5C13.35 9.2 13 9.05 12.6 9.05H7.5V6.5H8Z"
        fill="url(#tag3dHighlight)"
      />
      {/* Grommet / Hole in Tag */}
      <circle cx="10.5" cy="10.5" r="2.5" fill="#FFFFFF" />
      <circle cx="10.5" cy="10.5" r="1.3" fill="#0891B2" />
    </g>
  </svg>
);

// 14. Unified 3D Copy / Clipboard Document Icon
export const Copy3DIcon = ({ size = 18, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="copy3dBack" x1="4" y1="4" x2="22" y2="22" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#CBD5E1" />
        <stop offset="100%" stopColor="#94A3B8" />
      </linearGradient>
      <linearGradient id="copy3dFront" x1="10" y1="10" x2="28" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#00E5FF" />
        <stop offset="50%" stopColor="#00BADA" />
        <stop offset="100%" stopColor="#0891B2" />
      </linearGradient>
      <filter id="copy3dShadow" x="1" y="2" width="30" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#0891B2" floodOpacity="0.25" />
      </filter>
    </defs>
    <g filter="url(#copy3dShadow)">
      {/* Back Layer Sheet */}
      <rect x="5" y="5" width="16" height="18" rx="3" fill="url(#copy3dBack)" />
      {/* Front Primary Sheet */}
      <rect x="11" y="9" width="16" height="18" rx="3" fill="url(#copy3dFront)" stroke="#FFFFFF" strokeWidth="1" />
      {/* Document Text Lines */}
      <line x1="14" y1="14" x2="23" y2="14" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeOpacity="0.9" />
      <line x1="14" y1="18" x2="21" y2="18" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeOpacity="0.9" />
      <line x1="14" y1="22" x2="18" y2="22" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeOpacity="0.75" />
    </g>
  </svg>
);

// 15. Unified 3D Emerald Checkmark Badge Icon
export const Check3DIcon = ({ size = 18, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="chk3dGrad" x1="4" y1="4" x2="28" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#34D399" />
        <stop offset="50%" stopColor="#10B981" />
        <stop offset="100%" stopColor="#059669" />
      </linearGradient>
      <filter id="chk3dShadow" x="1" y="2" width="30" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#059669" floodOpacity="0.3" />
      </filter>
    </defs>
    <g filter="url(#chk3dShadow)">
      <circle cx="16" cy="16" r="12" fill="url(#chk3dGrad)" />
      {/* Top Gloss Highlight */}
      <ellipse cx="16" cy="9.5" rx="6" ry="2.5" fill="#FFFFFF" fillOpacity="0.35" />
      {/* Checkmark */}
      <path
        d="M10.5 16.5L14.2 20.2L21.5 12.8"
        stroke="#FFFFFF"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

// 16. Unified 3D Navigation / Directions Compass Pointer Icon
export const Directions3DIcon = ({ size = 18, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="dir3dGrad" x1="4" y1="4" x2="28" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#00E5FF" />
        <stop offset="50%" stopColor="#00BADA" />
        <stop offset="100%" stopColor="#0891B2" />
      </linearGradient>
      <filter id="dir3dShadow" x="1" y="2" width="30" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#0891B2" floodOpacity="0.28" />
      </filter>
    </defs>
    <g filter="url(#dir3dShadow)">
      {/* 3D Navigation Arrow Body */}
      <path
        d="M26.5 5.5L15 26.5L12 17.5L3 14.5L26.5 5.5Z"
        fill="url(#dir3dGrad)"
        stroke="#FFFFFF"
        strokeWidth="1"
        strokeLinejoin="round"
      />
      {/* Facet Shader for 3D depth */}
      <path
        d="M26.5 5.5L12 17.5L15 26.5L26.5 5.5Z"
        fill="#0088B3"
        fillOpacity="0.4"
      />
      {/* Top Gloss Flare */}
      <circle cx="24" cy="8" r="1.5" fill="#FFFFFF" fillOpacity="0.8" />
    </g>
  </svg>
);

// 17. Unified 3D Add Speaker / Presenter Icon (Doctor Profile with 3D Action Plus Badge)
export const AddSpeaker3DIcon = ({ size = 32, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="addSpkTorso" x1="6" y1="12" x2="26" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#38BDF8" />
        <stop offset="50%" stopColor="#0284C7" />
        <stop offset="100%" stopColor="#0369A1" />
      </linearGradient>
      <linearGradient id="addSpkHead" x1="11" y1="4" x2="21" y2="16" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#7DD3FC" />
        <stop offset="100%" stopColor="#0284C7" />
      </linearGradient>
      <linearGradient id="addSpkPlusBadge" x1="16" y1="16" x2="29" y2="29" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#00E5FF" />
        <stop offset="50%" stopColor="#00BADA" />
        <stop offset="100%" stopColor="#0891B2" />
      </linearGradient>
      <filter id="addSpkShadow" x="1" y="2" width="30" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#0284C7" floodOpacity="0.25" />
      </filter>
      <filter id="addSpkBadgeShadow" x="15" y="15" width="16" height="16" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="1.5" stdDeviation="1" floodColor="#0891B2" floodOpacity="0.35" />
      </filter>
    </defs>
    <g filter="url(#addSpkShadow)">
      {/* 3D Speaker Avatar Head */}
      <circle cx="15" cy="10" r="4.5" fill="url(#addSpkHead)" />
      <ellipse cx="13.8" cy="8" rx="1.6" ry="0.9" fill="#FFFFFF" fillOpacity="0.5" />

      {/* 3D Speaker Avatar Torso */}
      <path
        d="M6.5 25C6.5 19.5 10 16 15 16C17.2 16 19.2 16.7 20.8 17.9C19.7 19.6 19.5 21.8 20.2 23.8L20.8 25H6.5Z"
        fill="url(#addSpkTorso)"
      />
      {/* Tie / Lapel Highlight */}
      <path d="M13 16.5L15 20L17 16.5" stroke="#FFFFFF" strokeWidth="1.2" strokeLinecap="round" strokeOpacity="0.6" />
    </g>
    {/* 3D Plus Action Badge */}
    <g filter="url(#addSpkBadgeShadow)">
      <circle cx="23" cy="23" r="5.5" fill="url(#addSpkPlusBadge)" stroke="#FFFFFF" strokeWidth="1.5" />
      {/* Plus Symbol */}
      <line x1="23" y1="20" x2="23" y2="26" stroke="#FFFFFF" strokeWidth="1.6" strokeLinecap="round" />
      <line x1="20" y1="23" x2="26" y2="23" stroke="#FFFFFF" strokeWidth="1.6" strokeLinecap="round" />
    </g>
  </svg>
);

// 18. Unified 3D Plus Action Button Icon
export const Plus3DIcon = ({ size = 28, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="plus3dBody" x1="4" y1="4" x2="28" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#00E5FF" />
        <stop offset="50%" stopColor="#00BADA" />
        <stop offset="100%" stopColor="#0891B2" />
      </linearGradient>
      <filter id="plus3dShadow" x="1" y="2" width="30" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#0891B2" floodOpacity="0.28" />
      </filter>
    </defs>
    <g filter="url(#plus3dShadow)">
      <circle cx="16" cy="16" r="12" fill="url(#plus3dBody)" />
      {/* Gloss Highlight Arc */}
      <ellipse cx="16" cy="9.5" rx="6.5" ry="2.8" fill="#FFFFFF" fillOpacity="0.4" />
      {/* 3D Plus Symbol */}
      <line x1="16" y1="10.5" x2="16" y2="21.5" stroke="#FFFFFF" strokeWidth="2.5" strokeLinecap="round" />
      <line x1="10.5" y1="16" x2="21.5" y2="16" stroke="#FFFFFF" strokeWidth="2.5" strokeLinecap="round" />
    </g>
  </svg>
);

// 19. Unified 3D Heart / Favorite Icon
export const Heart3DIcon = ({ size = 24, isLiked = false, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0, transition: "transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1)" }}
  >
    <defs>
      {/* Active Liked Gradient (Red rose gradient matching AgendaItemCard.jsx) */}
      <linearGradient id="heartLikedGrad" x1="4" y1="4" x2="28" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#F43F5E" />
        <stop offset="45%" stopColor="#E11D48" />
        <stop offset="100%" stopColor="#BE123C" />
      </linearGradient>
      {/* Inactive Neutral Heart (Slate / Frosted Grey 3D) */}
      <linearGradient id="heartUnlikedGrad" x1="4" y1="4" x2="28" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#CBD5E1" />
        <stop offset="60%" stopColor="#94A3B8" />
        <stop offset="100%" stopColor="#64748B" />
      </linearGradient>
      <linearGradient id="heartSheen" x1="8" y1="6" x2="16" y2="14" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#FFFFFF" stopOpacity="0.85" />
        <stop offset="100%" stopColor="#FFFFFF" stopOpacity="0" />
      </linearGradient>
      <filter id="heartShadow" x="1" y="2" width="30" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow
          dx="0"
          dy="2"
          stdDeviation="1.5"
          floodColor={isLiked ? "#E11D48" : "#64748B"}
          floodOpacity={isLiked ? "0.4" : "0.2"}
        />
      </filter>
    </defs>
    <g filter="url(#heartShadow)">
      {/* 3D Heart Main Body */}
      <path
        d="M16 26.5C15.4 26.5 14.8 26.2 14.4 25.8C10.5 22.2 4 16.5 4 10.8C4 6.5 7.4 3.5 11.5 3.5C13.8 3.5 15.1 4.5 16 5.5C16.9 4.5 18.2 3.5 20.5 3.5C24.6 3.5 28 6.5 28 10.8C28 16.5 21.5 22.2 17.6 25.8C17.2 26.2 16.6 26.5 16 26.5Z"
        fill={isLiked ? "url(#heartLikedGrad)" : "url(#heartUnlikedGrad)"}
      />
      {/* Left Chamber Gloss Highlight */}
      <ellipse cx="10.5" cy="8.2" rx="3.2" ry="1.8" fill="url(#heartSheen)" transform="rotate(-25 10.5 8.2)" />
      {/* Subtle Rim Light on right */}
      <circle cx="21.5" cy="7.5" r="1.3" fill="#FFFFFF" fillOpacity="0.75" />
    </g>
  </svg>
);

// 20. Unified 3D Share / Export Tray Icon
export const Share3DIcon = ({ size = 24, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="shareArrowGrad" x1="16" y1="4" x2="16" y2="20" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#00E5FF" />
        <stop offset="50%" stopColor="#00BADA" />
        <stop offset="100%" stopColor="#0891B2" />
      </linearGradient>
      <linearGradient id="shareTrayGrad" x1="6" y1="14" x2="26" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#64748B" />
        <stop offset="100%" stopColor="#334155" />
      </linearGradient>
      <filter id="shareTrayShadow" x="1" y="2" width="30" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="1.5" stdDeviation="1.2" floodColor="#0891B2" floodOpacity="0.25" />
      </filter>
    </defs>
    <g filter="url(#shareTrayShadow)">
      {/* Share Tray */}
      <path
        d="M8 15V23C8 24.6569 9.34315 26 11 26H21C22.6569 26 24 24.6569 24 23V15"
        stroke="url(#shareTrayGrad)"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {/* Upward Arrow Shaft */}
      <path
        d="M16 5V18"
        stroke="url(#shareArrowGrad)"
        strokeWidth="2.6"
        strokeLinecap="round"
      />
      {/* Upward Arrowhead */}
      <path
        d="M10.5 10.5L16 5L21.5 10.5"
        stroke="url(#shareArrowGrad)"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

// 23. Playful Curved CTA Doodle Arrow
export const AgendaCtaDoodleArrow = ({ size = 38, color = "#A78BFA", className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-cta-doodle-arrow ${className}`}
    style={{ flexShrink: 0 }}
  >
    {/* Swirly Loop Path */}
    <path
      d="M34 29C33 24 30.5 19 26.5 17.5C23 16 20.8 20.2 23.2 23C25.2 25.2 28.2 23.2 27.5 20C26.5 15 19 10.5 6.5 9.5"
      stroke={color}
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {/* Arrowhead pointing Left-Upward towards CTA button */}
    <path
      d="M13.5 5L5.5 9.5L13 14.5"
      stroke={color}
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// 21. Unified 3D Trash Can / Delete Icon
export const Delete3DIcon = ({ size = 22, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="delCanGrad" x1="6" y1="10" x2="26" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#FF6B6B" />
        <stop offset="50%" stopColor="#F43F5E" />
        <stop offset="100%" stopColor="#E11D48" />
      </linearGradient>
      <linearGradient id="delLidGrad" x1="4" y1="6" x2="28" y2="12" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#FFA07A" />
        <stop offset="100%" stopColor="#F43F5E" />
      </linearGradient>
      <filter id="delShadow" x="1" y="2" width="30" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#F43F5E" floodOpacity="0.28" />
      </filter>
    </defs>
    <g filter="url(#delShadow)">
      {/* Can Body */}
      <path
        d="M8.5 12.5L10 26C10.2 27.1 11.1 28 12.2 28H19.8C20.9 28 21.8 27.1 22 26L23.5 12.5H8.5Z"
        fill="url(#delCanGrad)"
      />
      {/* Front Gloss Highlights on Body Flutes */}
      <line x1="13" y1="16" x2="13" y2="24" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeOpacity="0.6" />
      <line x1="16" y1="16" x2="16" y2="24" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeOpacity="0.85" />
      <line x1="19" y1="16" x2="19" y2="24" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round" strokeOpacity="0.6" />
      {/* Lid Flange */}
      <rect x="6" y="9" width="20" height="3.5" rx="1.75" fill="url(#delLidGrad)" />
      <rect x="7" y="9.5" width="18" height="1" rx="0.5" fill="#FFFFFF" fillOpacity="0.5" />
      {/* Lid Handle */}
      <rect x="13" y="5.5" width="6" height="3.5" rx="1.5" fill="#FFA07A" />
    </g>
  </svg>
);

// 22. Unified 3D Edit / Pencil Stylus Icon
export const Edit3DIcon = ({ size = 20, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="edit3dBody" x1="4" y1="4" x2="28" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#FFFFFF" />
        <stop offset="100%" stopColor="#F1F5F9" />
      </linearGradient>
      <linearGradient id="edit3dTip" x1="4" y1="20" x2="12" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#FDE047" />
        <stop offset="100%" stopColor="#EAB308" />
      </linearGradient>
      <filter id="edit3dShadow" x="1" y="2" width="30" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="1.5" stdDeviation="1.2" floodColor="#000000" floodOpacity="0.2" />
      </filter>
    </defs>
    <g filter="url(#edit3dShadow)">
      {/* Rotated Pencil Eraser / Top Cap */}
      <path
        d="M26.2 5.8C27.3 6.9 27.3 8.6 26.2 9.7L22.5 13.4L18.6 9.5L22.3 5.8C23.4 4.7 25.1 4.7 26.2 5.8Z"
        fill="#00E5FF"
      />
      {/* Pencil Barrel */}
      <path
        d="M21.2 14.7L17.3 10.8L9.5 18.6C9.2 18.9 9 19.3 8.9 19.7L7.5 24.5L12.3 23.1C12.7 23 13.1 22.8 13.4 22.5L21.2 14.7Z"
        fill="url(#edit3dBody)"
      />
      {/* Pencil Lead Tip */}
      <path d="M7.5 24.5L9.5 23.9L8.1 22.5L7.5 24.5Z" fill="#0F172A" />
      {/* Striped Facet Highlights */}
      <line x1="16.5" y1="12" x2="10" y2="18.5" stroke="#00BADA" strokeWidth="1.2" strokeLinecap="round" />
    </g>
  </svg>
);

// 23. Curved Organic Brushstroke Doodle Underline ("cutty cutty" textured curved line across dynamic title)
export const CurvedBrushUnderline = ({
  width = "100%",
  height = 9,
  color = "#00BADA",
  className = "",
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 300 12"
    preserveAspectRatio="none"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-details-brush-underline ${className}`}
    style={{ display: "block", flexShrink: 0 }}
  >
    {/* Main Hand-drawn Curved Brush Stroke with textured/organic edges */}
    <path
      d="M2.5 6.2C18.8 4.6 38.6 5.4 58.3 5.2C95.2 4.8 132.1 5.6 168.9 6.7C206.1 7.7 243.4 8.1 280.6 7.2C288.9 6.8 295.3 5.9 299.4 4.7C300.6 4.5 301.2 5.4 300.4 6.2C298.8 7.8 294.6 8.2 288.2 8.5C252.6 9.9 218.0 10.0 182.4 9.3C148.2 8.6 113.9 7.4 78.7 6.8C53.9 6.4 28.1 7.1 6.4 8.8C4.5 9.1 2.5 8.9 1.4 7.6C0.6 6.8 0.9 5.9 2.5 6.2Z"
      fill={color}
    />
  </svg>
);

// 24. Unified 3D Zoom Brand Icon (Reversed: Frosted Light Blue Pill with 3D Royal Blue Camera & Zoom Typography)
export const Zoom3DIcon = ({
  height = 18,
  width,
  size,
  className = "",
  style = {},
}) => {
  const finalHeight = size || height;
  const resolvedWidth = width || Math.round((finalHeight * 50) / 20);

  return (
    <svg
      width={resolvedWidth}
      height={finalHeight}
      viewBox="0 0 50 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`agenda-3d-icon agenda-3d-zoom-badge ${className}`}
      style={{
        flexShrink: 0,
        display: "inline-block",
        verticalAlign: "middle",
        ...style,
      }}
      title="Zoom"
    >
      <defs>
        {/* Soft Frosted Light Blue Pill Gradient */}
        <linearGradient id="zoomLightPillGrad" x1="2" y1="2" x2="48" y2="18" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#FFFFFF" />
          <stop offset="50%" stopColor="#F0F7FF" />
          <stop offset="100%" stopColor="#E1F0FE" />
        </linearGradient>
        {/* Vibrant 3D Zoom Royal Blue Gradient for Camera & Text */}
        <linearGradient id="zoom3dBlueGrad" x1="5" y1="5" x2="45" y2="15" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#2E8CFF" />
          <stop offset="50%" stopColor="#0E71EB" />
          <stop offset="100%" stopColor="#004ECB" />
        </linearGradient>
        <filter id="zoomLightShadow" x="0" y="0" width="50" height="22" filterUnits="userSpaceOnUse">
          <feDropShadow dx="0" dy="1" stdDeviation="0.8" floodColor="#0E71EB" floodOpacity="0.12" />
        </filter>
      </defs>
      <g filter="url(#zoomLightShadow)">
        {/* Frosted Light Blue Pill Base (Compact right padding) */}
        <rect
          x="1"
          y="1"
          width="48"
          height="17.5"
          rx="5.5"
          fill="url(#zoomLightPillGrad)"
          stroke="rgba(14, 113, 235, 0.22)"
          strokeWidth="0.8"
        />
        {/* Top Gloss Arc */}
        <path
          d="M4 2.5C4 1.8 6 1.4 8.5 1.4H41.5C44 1.4 46 1.8 46 2.5C46 3.6 43.5 4.6 41 4.6H9C6.5 4.6 4 3.6 4 2.5Z"
          fill="#FFFFFF"
          fillOpacity="0.8"
        />
        {/* 3D Camera Body in Zoom Blue (Centered vertically at y=9.75) */}
        <rect x="5.5" y="5.85" width="7.8" height="7.8" rx="2" fill="url(#zoom3dBlueGrad)" />
        {/* Perspective Lens Cone (Centered vertically at y=9.75) */}
        <path
          d="M13.8 7.75L17.5 5.55C17.9 5.25 18.5 5.55 18.5 6.05V13.45C18.5 13.95 17.9 14.25 17.5 13.95L13.8 11.75V7.75Z"
          fill="url(#zoom3dBlueGrad)"
        />
        {/* Inner Camera Lens Specular Sheen */}
        <circle cx="8" cy="7.85" r="0.75" fill="#FFFFFF" fillOpacity="0.75" />

        {/* 3D "zoom" Wordmark in Zoom Blue (Mathematically & Visually Centered at y=9.75) */}
        <text
          x="21.5"
          y="9.75"
          dominantBaseline="central"
          alignmentBaseline="central"
          fill="url(#zoom3dBlueGrad)"
          fontFamily="-apple-system, BlinkMacSystemFont, 'Outfit', 'Inter', 'Segoe UI', Roboto, sans-serif"
          fontWeight="800"
          fontSize="9.5"
          letterSpacing="-0.2px"
        >
          zoom
        </text>
      </g>
    </svg>
  );
};

// 25. Unified 3D Spots / Seats Icon (Auditorium / Theater Seat with Gloss Sheen & Sparkle Badge)
export const Spots3DIcon = ({ size = 20, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      {/* 3D Seat Backrest Gradient */}
      <linearGradient id="spotSeatBack" x1="8" y1="5" x2="24" y2="19" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#00E5FF" />
        <stop offset="50%" stopColor="#00BADA" />
        <stop offset="100%" stopColor="#0891B2" />
      </linearGradient>
      {/* 3D Seat Cushion Gradient */}
      <linearGradient id="spotSeatCushion" x1="6" y1="16" x2="26" y2="24" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#38BDF8" />
        <stop offset="60%" stopColor="#0284C7" />
        <stop offset="100%" stopColor="#0369A1" />
      </linearGradient>
      {/* 3D Armrest / Base Gradient */}
      <linearGradient id="spotArmBase" x1="4" y1="14" x2="28" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#94A3B8" />
        <stop offset="100%" stopColor="#475569" />
      </linearGradient>
      {/* Star / Sparkle Gradient */}
      <linearGradient id="spotSparkleGrad" x1="21" y1="3" x2="29" y2="11" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#FDE047" />
        <stop offset="100%" stopColor="#EAB308" />
      </linearGradient>
      <filter id="spotSeatShadow" x="1" y="2" width="30" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#0891B2" floodOpacity="0.25" />
      </filter>
    </defs>
    <g filter="url(#spotSeatShadow)">
      {/* Auditorium Seat Backrest */}
      <rect x="9" y="5.5" width="14" height="13" rx="4" fill="url(#spotSeatBack)" />
      {/* Backrest Gloss Highlight */}
      <rect x="11" y="7" width="10" height="2.5" rx="1.25" fill="#FFFFFF" fillOpacity="0.4" />
      {/* Vertical Cushion Creases */}
      <line x1="13.5" y1="10" x2="13.5" y2="16" stroke="#FFFFFF" strokeWidth="1" strokeOpacity="0.3" strokeLinecap="round" />
      <line x1="18.5" y1="10" x2="18.5" y2="16" stroke="#FFFFFF" strokeWidth="1" strokeOpacity="0.3" strokeLinecap="round" />

      {/* Seat Cushion (Bottom Plate) */}
      <path
        d="M6.5 17.5C6.5 16.4 7.4 15.5 8.5 15.5H23.5C24.6 15.5 25.5 16.4 25.5 17.5V20.5C25.5 22.1569 24.1569 23.5 22.5 23.5H9.5C7.84315 23.5 6.5 22.1569 6.5 20.5V17.5Z"
        fill="url(#spotSeatCushion)"
      />
      {/* Cushion Top Rim Highlight */}
      <path d="M8 17H24" stroke="#FFFFFF" strokeWidth="1.2" strokeOpacity="0.5" strokeLinecap="round" />

      {/* Left Armrest */}
      <rect x="4.5" y="14" width="3" height="7.5" rx="1.5" fill="url(#spotArmBase)" />
      {/* Right Armrest */}
      <rect x="24.5" y="14" width="3" height="7.5" rx="1.5" fill="url(#spotArmBase)" />

      {/* Center Pedestal Leg */}
      <rect x="14.5" y="23" width="3" height="4" rx="1" fill="url(#spotArmBase)" />
      {/* Base Floor Stand */}
      <rect x="10.5" y="26.5" width="11" height="2" rx="1" fill="url(#spotArmBase)" />

      {/* Top Right Activity / Golden Spot Star Sparkle */}
      <path
        d="M25 4L25.8 6.2L28 7L25.8 7.8L25 10L24.2 7.8L22 7L24.2 6.2L25 4Z"
        fill="url(#spotSparkleGrad)"
      />
    </g>
  </svg>
);

export const Seats3DIcon = Spots3DIcon;

// 31. Unified 3D Form Submission / Clipboard Review Icon
export const FormSubmission3DIcon = ({ size = 28, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      {/* Board Base Gradient */}
      <linearGradient id="clipBoardGrad" x1="4" y1="5" x2="28" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#00E5FF" />
        <stop offset="50%" stopColor="#00BADA" />
        <stop offset="100%" stopColor="#0891B2" />
      </linearGradient>
      {/* Clip Metallic Gradient */}
      <linearGradient id="clipMetalGrad" x1="10" y1="2" x2="22" y2="8" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#F8FAFC" />
        <stop offset="50%" stopColor="#CBD5E1" />
        <stop offset="100%" stopColor="#94A3B8" />
      </linearGradient>
      {/* Sheet Gradient */}
      <linearGradient id="clipSheetGrad" x1="6" y1="8" x2="26" y2="26" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#FFFFFF" />
        <stop offset="100%" stopColor="#F8FAFC" />
      </linearGradient>
      {/* Success Badge */}
      <linearGradient id="clipBadgeGrad" x1="18" y1="18" x2="28" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#34D399" />
        <stop offset="100%" stopColor="#059669" />
      </linearGradient>
      <filter id="clipShadow" x="1" y="2" width="30" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#0891B2" floodOpacity="0.25" />
      </filter>
      <filter id="badgeShadow" x="17" y="17" width="13" height="13" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="1.5" stdDeviation="1" floodColor="#059669" floodOpacity="0.3" />
      </filter>
    </defs>
    <g filter="url(#clipShadow)">
      {/* Main Board */}
      <rect x="4.5" y="5.5" width="23" height="22" rx="4" fill="url(#clipBoardGrad)" />
      {/* Document Sheet */}
      <rect x="6.5" y="8" width="19" height="17.5" rx="2.5" fill="url(#clipSheetGrad)" />
      {/* Form Checklist Lines */}
      {/* Item 1 */}
      <rect x="8.5" y="11.5" width="2.5" height="2.5" rx="0.6" fill="#00BADA" />
      <rect x="12.5" y="12" width="9.5" height="1.5" rx="0.75" fill="#94A3B8" />
      {/* Item 2 */}
      <rect x="8.5" y="15.5" width="2.5" height="2.5" rx="0.6" fill="#00BADA" />
      <rect x="12.5" y="16" width="7" height="1.5" rx="0.75" fill="#CBD5E1" />
      {/* Item 3 */}
      <rect x="8.5" y="19.5" width="2.5" height="2.5" rx="0.6" fill="#00BADA" />
      <rect x="12.5" y="20" width="5.5" height="1.5" rx="0.75" fill="#CBD5E1" />
      {/* Metallic Top Clip */}
      <path
        d="M11 4.5C11 3.67157 11.6716 3 12.5 3H19.5C20.3284 3 21 3.67157 21 4.5V7H11V4.5Z"
        fill="url(#clipMetalGrad)"
      />
      <rect x="13.5" y="4.5" width="5" height="1.5" rx="0.75" fill="#FFFFFF" fillOpacity="0.8" />
    </g>
    {/* Verified Check Badge on Bottom-Right */}
    <g filter="url(#badgeShadow)">
      <circle cx="23" cy="23" r="5" fill="url(#clipBadgeGrad)" stroke="#FFFFFF" strokeWidth="1.5" />
      <path
        d="M20.5 23L22.2 24.7L25.5 21.3"
        stroke="#FFFFFF"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

// 32. Unified 3D Collective Submissions / Stacked Forms Icon
export const AllSubmissions3DIcon = ({ size = 28, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="allSubBack" x1="4" y1="4" x2="22" y2="24" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#38BDF8" />
        <stop offset="100%" stopColor="#0284C7" />
      </linearGradient>
      <linearGradient id="allSubFront" x1="8" y1="7" x2="28" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#00E5FF" />
        <stop offset="50%" stopColor="#00BADA" />
        <stop offset="100%" stopColor="#0891B2" />
      </linearGradient>
      <filter id="allSubShadow" x="1" y="2" width="30" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#0891B2" floodOpacity="0.25" />
      </filter>
    </defs>
    <g filter="url(#allSubShadow)">
      {/* Back Form Layer */}
      <rect x="4" y="5" width="18" height="19" rx="3" fill="url(#allSubBack)" opacity="0.6" />
      {/* Middle Layer Offset */}
      <rect x="7" y="7" width="18" height="19" rx="3" fill="#FFFFFF" opacity="0.9" />
      {/* Front Form Board */}
      <rect x="9.5" y="8.5" width="18" height="19" rx="3.5" fill="url(#allSubFront)" />
      {/* Front White Paper */}
      <rect x="11.5" y="11" width="14" height="14.5" rx="2" fill="#FFFFFF" />
      {/* Form Lines */}
      <rect x="13.5" y="13.5" width="2" height="2" rx="0.5" fill="#00BADA" />
      <rect x="16.5" y="14" width="7" height="1.2" rx="0.6" fill="#64748B" />
      <rect x="13.5" y="17" width="2" height="2" rx="0.5" fill="#00BADA" />
      <rect x="16.5" y="17.5" width="5.5" height="1.2" rx="0.6" fill="#94A3B8" />
      <rect x="13.5" y="20.5" width="2" height="2" rx="0.5" fill="#34D399" />
      <rect x="16.5" y="21" width="4" height="1.2" rx="0.6" fill="#94A3B8" />
      {/* Clip on top */}
      <rect x="15" y="6.5" width="7" height="3" rx="1.5" fill="#CBD5E1" stroke="#FFFFFF" strokeWidth="0.8" />
    </g>
  </svg>
);

// 33. Unified 3D Photo / Media Response Icon
export const PhotoSubmission3DIcon = ({ size = 28, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="photoBodyGrad" x1="4" y1="6" x2="28" y2="26" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#818CF8" />
        <stop offset="50%" stopColor="#6366F1" />
        <stop offset="100%" stopColor="#4F46E5" />
      </linearGradient>
      <filter id="photoShadow" x="1" y="3" width="30" height="26" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#4F46E5" floodOpacity="0.25" />
      </filter>
    </defs>
    <g filter="url(#photoShadow)">
      {/* Frame Plate */}
      <rect x="4" y="6.5" width="24" height="19" rx="3.5" fill="url(#photoBodyGrad)" />
      {/* Inner Viewport */}
      <rect x="6" y="8.5" width="20" height="15" rx="2" fill="#FFFFFF" fillOpacity="0.95" />
      {/* Sun/Lens Circle */}
      <circle cx="10.5" cy="12.5" r="2.2" fill="#FBBF24" />
      {/* Mountains/Waves */}
      <path
        d="M6 21.5L12 15L17 20L20 17L26 23.5H6V21.5Z"
        fill="#6366F1"
        fillOpacity="0.8"
      />
      {/* Gloss Sheen */}
      <path d="M7 9H25" stroke="#FFFFFF" strokeWidth="1" strokeOpacity="0.6" strokeLinecap="round" />
    </g>
  </svg>
);

// 34. Unified 3D Video Response Icon
export const VideoSubmission3DIcon = ({ size = 28, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="vidSubGrad" x1="4" y1="6" x2="28" y2="26" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#F43F5E" />
        <stop offset="50%" stopColor="#E11D48" />
        <stop offset="100%" stopColor="#BE123C" />
      </linearGradient>
      <filter id="vidSubShadow" x="1" y="3" width="30" height="26" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#E11D48" floodOpacity="0.25" />
      </filter>
    </defs>
    <g filter="url(#vidSubShadow)">
      {/* Frame Plate */}
      <rect x="4" y="6.5" width="24" height="19" rx="3.5" fill="url(#vidSubGrad)" />
      {/* Inner Screen */}
      <rect x="6.5" y="9" width="19" height="14" rx="2" fill="#1E293B" />
      {/* White Play Triangle */}
      <path
        d="M14 12.5L19.5 16L14 19.5V12.5Z"
        fill="#FFFFFF"
      />
      {/* Gloss Sheen */}
      <path d="M7 7.5H25" stroke="#FFFFFF" strokeWidth="1" strokeOpacity="0.5" strokeLinecap="round" />
    </g>
  </svg>
);

// 35. Unified 3D Checklist Icon
export const Checklist3DIcon = ({ size = 28, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="chkUniGrad" x1="4" y1="5" x2="28" y2="27" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#10B981" />
        <stop offset="50%" stopColor="#059669" />
        <stop offset="100%" stopColor="#047857" />
      </linearGradient>
      <filter id="chkShadow" x="1" y="2" width="30" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#059669" floodOpacity="0.25" />
      </filter>
    </defs>
    <g filter="url(#chkShadow)">
      <rect x="4" y="5.5" width="24" height="21" rx="4" fill="url(#chkUniGrad)" />
      {/* White Plate */}
      <rect x="6.5" y="8" width="19" height="16" rx="2.5" fill="#FFFFFF" fillOpacity="0.95" />
      {/* Checklist Marks */}
      <path d="M9 12L10.5 13.5L13 11" stroke="#059669" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="15" y="11.5" width="8" height="1.5" rx="0.75" fill="#64748B" />
      <path d="M9 16L10.5 17.5L13 15" stroke="#059669" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="15" y="15.5" width="6" height="1.5" rx="0.75" fill="#94A3B8" />
      <path d="M9 20L10.5 21.5L13 19" stroke="#059669" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="15" y="19.5" width="7" height="1.5" rx="0.75" fill="#94A3B8" />
    </g>
  </svg>
);

// 36. 3D Star of Specialty Icon
export const Specialist3DIcon = ({ size = 26, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="amSpec3dGrad" x1="4" y1="4" x2="28" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#00E5FF" />
        <stop offset="50%" stopColor="#00BADA" />
        <stop offset="100%" stopColor="#0891B2" />
      </linearGradient>
      <linearGradient id="amSpecStarGrad" x1="10" y1="8" x2="22" y2="24" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#FFFFFF" />
        <stop offset="100%" stopColor="#E0F7FA" />
      </linearGradient>
      <filter id="amSpec3dShadow" x="1" y="2" width="30" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#0891B2" floodOpacity="0.28" />
      </filter>
    </defs>
    <g filter="url(#amSpec3dShadow)">
      <circle cx="16" cy="16" r="12" fill="url(#amSpec3dGrad)" />
      <ellipse cx="16" cy="9.5" rx="6" ry="2.2" fill="#FFFFFF" fillOpacity="0.4" />
      <path
        d="M16 8L18.2 12.8L23.2 13.4L19.4 16.9L20.4 22L16 19.4L11.6 22L12.6 16.9L8.8 13.4L13.8 12.8L16 8Z"
        fill="url(#amSpecStarGrad)"
        stroke="#008AA8"
        strokeWidth="0.5"
      />
      <circle cx="16" cy="15.5" r="1.3" fill="#00BADA" />
    </g>
  </svg>
);

// 37. 3D Location Marker Pin Icon
export const LocationPin3DIcon = ({ size = 26, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="amLoc3dGrad" x1="6" y1="4" x2="26" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#38BDF8" />
        <stop offset="50%" stopColor="#00BADA" />
        <stop offset="100%" stopColor="#0369A1" />
      </linearGradient>
      <filter id="amLoc3dShadow" x="2" y="2" width="28" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#0284C7" floodOpacity="0.28" />
      </filter>
    </defs>
    <g filter="url(#amLoc3dShadow)">
      <path
        d="M16 4C10.4772 4 6 8.47715 6 14C6 20.8 14.5 27.2 15.35 27.82C15.74 28.1 16.26 28.1 16.65 27.82C17.5 27.2 26 20.8 26 14C26 8.47715 21.5228 4 16 4Z"
        fill="url(#amLoc3dGrad)"
      />
      <circle cx="16" cy="13.5" r="4.2" fill="#FFFFFF" />
      <circle cx="16" cy="13.5" r="2" fill="#00BADA" />
      <ellipse cx="14" cy="8" rx="4" ry="1.8" fill="#FFFFFF" fillOpacity="0.45" />
    </g>
  </svg>
);

// 38. 3D "1:1" Mentorship Guidance Bubble Icon
export const OneToOne3DIcon = ({ size = 32, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="amOtoBodyGrad" x1="4" y1="4" x2="28" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#00E5FF" />
        <stop offset="50%" stopColor="#00BADA" />
        <stop offset="100%" stopColor="#0891B2" />
      </linearGradient>
      <filter id="amOtoShadow" x="1" y="2" width="30" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#0891B2" floodOpacity="0.28" />
      </filter>
    </defs>
    <g filter="url(#amOtoShadow)">
      <path
        d="M6 8C6 5.79086 7.79086 4 10 4H22C24.2091 4 26 5.79086 26 8V18C26 20.2091 24.2091 22 22 22H13.5L8 26.5V22H10C8.89543 22 6 20.1046 6 18V8Z"
        fill="url(#amOtoBodyGrad)"
      />
      <ellipse cx="16" cy="7" rx="6.5" ry="1.8" fill="#FFFFFF" fillOpacity="0.45" />
      <text
        x="16"
        y="14.8"
        textAnchor="middle"
        dominantBaseline="central"
        fill="#FFFFFF"
        fontFamily="'Onest', -apple-system, sans-serif"
        fontWeight="800"
        fontSize="9.5"
        letterSpacing="-0.2px"
      >
        1:1
      </text>
    </g>
  </svg>
);

// 39. 3D Rosette Shield Star Icon (Expert Support)
export const ExpertSupport3DIcon = ({ size = 32, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="amExpBadgeGrad" x1="4" y1="4" x2="28" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#38BDF8" />
        <stop offset="50%" stopColor="#0284C7" />
        <stop offset="100%" stopColor="#0369A1" />
      </linearGradient>
      <linearGradient id="amExpStarGrad" x1="10" y1="8" x2="22" y2="22" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#FDE047" />
        <stop offset="100%" stopColor="#EAB308" />
      </linearGradient>
      <filter id="amExpShadow" x="1" y="2" width="30" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#0284C7" floodOpacity="0.28" />
      </filter>
    </defs>
    <g filter="url(#amExpShadow)">
      <path
        d="M16 4L19.5 6.6L23.8 8L25 12.3L27 16.2L25 20.1L23.8 24.4L19.5 25.8L16 28.4L12.5 25.8L8.2 24.4L7 20.1L5 16.2L7 12.3L8.2 8L12.5 6.6L16 4Z"
        fill="url(#amExpBadgeGrad)"
      />
      <path
        d="M16 9.5L17.8 13.5L22.2 14L18.8 17.1L19.8 21.4L16 19.2L12.2 21.4L13.2 17.1L9.8 14L14.2 13.5L16 9.5Z"
        fill="url(#amExpStarGrad)"
        stroke="#FFFFFF"
        strokeWidth="0.8"
      />
      <circle cx="16" cy="15.5" r="1.2" fill="#FFFFFF" fillOpacity="0.85" />
      <path d="M11 9C12.5 7 16 7 19.5 8" stroke="#FFFFFF" strokeWidth="1" strokeLinecap="round" strokeOpacity="0.55" />
    </g>
  </svg>
);

// 40. 3D Career Growth Ascending Bars & Trending Arrow Icon
export const CareerGrowth3DIcon = ({ size = 32, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="amCgBar1" x1="6" y1="18" x2="10" y2="27" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#A5F3FC" />
        <stop offset="100%" stopColor="#06B6D4" />
      </linearGradient>
      <linearGradient id="amCgBar2" x1="12" y1="13" x2="16" y2="27" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#38BDF8" />
        <stop offset="100%" stopColor="#0284C7" />
      </linearGradient>
      <linearGradient id="amCgBar3" x1="18" y1="8" x2="22" y2="27" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#00E5FF" />
        <stop offset="100%" stopColor="#00BADA" />
      </linearGradient>
      <linearGradient id="amCgArrowGrad" x1="6" y1="6" x2="28" y2="20" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#00E5FF" />
        <stop offset="100%" stopColor="#0284C7" />
      </linearGradient>
      <filter id="amCgShadow" x="1" y="2" width="30" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#0891B2" floodOpacity="0.25" />
      </filter>
    </defs>
    <g filter="url(#amCgShadow)">
      <rect x="6.5" y="17.5" width="4.5" height="9.5" rx="1.5" fill="url(#amCgBar1)" />
      <rect x="13.5" y="12.5" width="4.5" height="14.5" rx="1.5" fill="url(#amCgBar2)" />
      <rect x="20.5" y="7.5" width="4.5" height="19.5" rx="1.5" fill="url(#amCgBar3)" />
      <rect x="7" y="18" width="3.5" height="1" rx="0.5" fill="#FFFFFF" fillOpacity="0.6" />
      <rect x="14" y="13" width="3.5" height="1" rx="0.5" fill="#FFFFFF" fillOpacity="0.6" />
      <rect x="21" y="8" width="3.5" height="1" rx="0.5" fill="#FFFFFF" fillOpacity="0.6" />
      <path
        d="M5 20.5L12 13.5L17.5 17L26 6.5"
        stroke="url(#amCgArrowGrad)"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 6.5H26V11.5"
        stroke="url(#amCgArrowGrad)"
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

// 41. 3D Chat Messaging Icon (Glossy Modern 3D Bubbles for Button)
export const Chat3DIcon = ({ size = 22, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="amChatGradMain" x1="4" y1="4" x2="26" y2="26" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#FFFFFF" />
        <stop offset="100%" stopColor="#E0F7FA" />
      </linearGradient>
      <linearGradient id="amChatGradBack" x1="12" y1="6" x2="28" y2="22" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#A5F3FC" stopOpacity="0.85" />
        <stop offset="100%" stopColor="#00BADA" stopOpacity="0.95" />
      </linearGradient>
      <filter id="amChatShadow" x="1" y="2" width="30" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#000000" floodOpacity="0.25" />
      </filter>
    </defs>
    <g filter="url(#amChatShadow)">
      {/* Background Secondary Bubble */}
      <path
        d="M14 6H24C26.2091 6 28 7.79086 28 10V17C28 19.2091 26.2091 21 24 21H23V25L18.5 21H14C11.7909 21 10 19.2091 10 17V15"
        fill="url(#amChatGradBack)"
      />
      {/* Foreground Main Bubble */}
      <path
        d="M4 10C4 7.79086 5.79086 6 8 6H18C20.2091 6 22 7.79086 22 10V18C22 20.2091 20.2091 22 18 22H11.5L6 26.5V22H8C6.89543 22 4 20.1046 4 18V10Z"
        fill="url(#amChatGradMain)"
      />
      {/* Gloss Highlight */}
      <ellipse cx="13" cy="9" rx="5.5" ry="1.5" fill="#FFFFFF" fillOpacity="0.8" />
      {/* 3 Chat Typing Dots */}
      <circle cx="9.5" cy="14" r="1.4" fill="#00BADA" />
      <circle cx="13" cy="14" r="1.4" fill="#0891B2" />
      <circle cx="16.5" cy="14" r="1.4" fill="#00BADA" />
    </g>
  </svg>
);

// 42. 3D Consultation Fee / Price Icon (3D Glossy Fee Card & Violet Currency Coin)
export const Fee3DIcon = ({ size = 26, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`agenda-3d-icon ${className}`}
    style={{ flexShrink: 0 }}
  >
    <defs>
      <linearGradient id="amFeeBodyGrad" x1="4" y1="4" x2="28" y2="28" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#38BDF8" />
        <stop offset="50%" stopColor="#00BADA" />
        <stop offset="100%" stopColor="#0284C7" />
      </linearGradient>
      <linearGradient id="amFeeCoinGrad" x1="12" y1="8" x2="28" y2="26" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#C084FC" />
        <stop offset="50%" stopColor="#A855F7" />
        <stop offset="100%" stopColor="#7E22CE" />
      </linearGradient>
      <filter id="amFeeShadow" x="1" y="2" width="30" height="28" filterUnits="userSpaceOnUse">
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodColor="#9333EA" floodOpacity="0.28" />
      </filter>
    </defs>
    <g filter="url(#amFeeShadow)">
      {/* Background Fee Card Base */}
      <rect x="4" y="8" width="22" height="15" rx="3.5" fill="url(#amFeeBodyGrad)" />
      <rect x="5.5" y="9.5" width="19" height="12" rx="2.5" fill="#FFFFFF" fillOpacity="0.18" />
      <line x1="8" y1="13" x2="13" y2="13" stroke="#FFFFFF" strokeWidth="1.2" strokeLinecap="round" strokeOpacity="0.85" />
      <line x1="8" y1="16.5" x2="12" y2="16.5" stroke="#FFFFFF" strokeWidth="1.2" strokeLinecap="round" strokeOpacity="0.65" />
      
      {/* Foreground Purple/Violet 3D Fee Coin */}
      <circle cx="21" cy="18" r="7.5" fill="url(#amFeeCoinGrad)" stroke="#FFFFFF" strokeWidth="1" />
      <circle cx="21" cy="18" r="5.5" fill="#9333EA" stroke="#E9D5FF" strokeWidth="0.6" />
      
      {/* Currency / Fee Symbol in Center */}
      <path
        d="M23 15.5C22.4 15.2 21.6 15 20.8 15C19.2 15 18 16.2 18 18C18 19.8 19.2 21 20.8 21C21.6 21 22.4 20.8 23 20.5M17 17H22M17 19H22"
        stroke="#FFFFFF"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      {/* Coin Top Sheen */}
      <ellipse cx="20" cy="13.5" rx="3.5" ry="1.2" fill="#FFFFFF" fillOpacity="0.5" />
    </g>
  </svg>
);



